import { render, staticRenderFns } from "./DefaultStep.vue?vue&type=template&id=a07bec44&"
import script from "./DefaultStep.vue?vue&type=script&lang=js&"
export * from "./DefaultStep.vue?vue&type=script&lang=js&"
import style0 from "./DefaultStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports